exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* CATALOG SHARING COMPONENT STYLES\n*/.sharing-type{font-size:.9em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./customer/app-core/catalog-sharing-type/catalog-sharing-type.useable.scss
// module id = 824
// module chunks = 0